import React from 'react';
import { DebounceInput } from 'react-debounce-input';

const NotesView = ({ notes, onChange }) => {
  return (
    <div className="notes">
      <DebounceInput
        element="textarea"
        debounceTimeout={300}
        placeholder="Write notes here..."
        forceNotifyByEnter={false}
        value={notes}
        onChange={e => onChange(e.target.value)}
      />
    </div>
  );
}

export default NotesView;
